import { TextMetrics as PixiTextMetrics } from '@pixi/text';
import { Rectangle } from 'pixi.js';

export const DEFAULT_TEXT_ALPHA = 1;
export const DEFAULT_SCALE = 1;

export function isNewline(text: string): boolean {
    // isNewline is declared as private inside PIXI
    return (PixiTextMetrics as any).isNewline(text);
}

export function isBreakingSpace(char: string): boolean {
    // isBreakingSpace is declared as private inside PIXI
    return (PixiTextMetrics as any).isBreakingSpace(char);
}

export function tokenize(text: string): string[] {
    // tokenize is declared as private inside PIXI
    return (PixiTextMetrics as any).tokenize(text);
}

export function metricsContext() {
    return (PixiTextMetrics as any)._context as
        | CanvasRenderingContext2D
        | OffscreenCanvasRenderingContext2D;
}

export function getTotalBounds(elements: Rectangle[]) {
    if (elements.length === 0) {
        return Rectangle.EMPTY;
    }
    const box = elements[0].clone();
    for (let i = 1; i < elements.length; i++) {
        if (elements[i].width > 0) {
            box.enlarge(elements[i]);
        }
    }
    return box;
}

export function getBoundsIntersection(bounds1: Rectangle, bounds2: Rectangle): Rectangle {
    if (!bounds1.intersects(bounds2)) {
        return Rectangle.EMPTY;
    }
    const x = Math.max(bounds1.x, bounds2.x);
    const y = Math.max(bounds1.y, bounds2.y);
    const width = Math.min(bounds1.x + bounds1.width, bounds2.x + bounds2.width) - x;
    const height = Math.min(bounds1.y + bounds1.height, bounds2.y + bounds2.height) - y;
    return new Rectangle(x, y, width, height);
}
